import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: "root",
})
export class DataService {

private subject = new BehaviorSubject<any>(null);

  constructor(private apiService: ApiService) { }

  getJsonData(url: any) {
    return this.apiService.getDoc(url);
  }

  getApiData(url: any) {
    return this.apiService.get(url);
  }

  getApiPostData(url: any, data: any) {
    return this.apiService.post(url, data);
  }

  getData(): Observable<any> {
    return this.subject.asObservable();
  }

  sendData(data: any) {
    this.subject.next(data);
  }
}
